// extracted by mini-css-extract-plugin
export default {"text":"NewsCard_text__EE+XB"};